<template>
  <section v-if="!collapsed" class="ai-agents" aria-label="Tracey agents">
    <h2 class="ai-agents__heading">Agents</h2>

    <v-menu
      v-for="agent in agents"
      :key="agent.key"
      open-on-hover
      offset-x
      nudge-right="8"
      :close-on-content-click="false"
      content-class="ai-agents__popover"
      min-width="300"
      max-width="340"
      transition="fade-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="ai-agents__row-btn" v-bind="attrs" v-on="on">
          <span class="ai-agents__dot" :style="{ background: agent.accent }" aria-hidden="true"></span>
          <span class="ai-agents__name">{{ agent.name }}</span>
          <v-icon size="16" color="#8e8ea0">mdi-information-outline</v-icon>
        </button>
      </template>

      <div class="ai-agents__card">
        <div class="ai-agents__card-head">
          <span class="ai-agents__dot" :style="{ background: agent.accent }" aria-hidden="true"></span>
          <span class="ai-agents__card-name">{{ agent.name }}</span>
        </div>
        <p class="ai-agents__desc">{{ agent.description }}</p>

        <h3 class="ai-agents__sub">Capabilities</h3>
        <ul class="ai-agents__list">
          <li v-for="cap in agent.capabilities" :key="cap" class="ai-agents__item-row">
            <v-icon size="13" :color="agent.accent">mdi-check-circle</v-icon>
            <span>{{ cap }}</span>
          </li>
        </ul>

        <template v-if="agent.dataSources && agent.dataSources.length">
          <h3 class="ai-agents__sub">Data sources</h3>
          <ul class="ai-agents__list">
            <li v-for="src in agent.dataSources" :key="src" class="ai-agents__item-row">
              <v-icon size="13" color="#8e8ea0">mdi-database-outline</v-icon>
              <span>{{ src }}</span>
            </li>
          </ul>
        </template>
      </div>
    </v-menu>
  </section>
</template>

<script>
import { TRACEY_AGENTS } from '../agentVersions.js';

export default {
  name: 'TraceyAiAgentInfo',
  props: {
    collapsed: { type: Boolean, default: false },
  },
  data() {
    return {
      agents: TRACEY_AGENTS,
    };
  },
};
</script>

<style scoped>
.ai-agents {
  flex-shrink: 0;
  border-top: 1px solid #ececf1;
  padding: 10px 8px 8px;
}

.ai-agents__heading {
  margin: 0 0 6px;
  padding: 0 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8e8ea0;
}

.ai-agents__row-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  background: transparent;
  cursor: default;
  transition: background-color 0.15s ease;
}

.ai-agents__row-btn:hover {
  background: #ececf1;
}

.ai-agents__dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.ai-agents__name {
  flex: 1;
  min-width: 0;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #12253a;
}
</style>

<!-- Not scoped: v-menu teleports its content outside this component's subtree. -->
<style>
.ai-agents__popover {
  border-radius: 12px;
  box-shadow: 0 6px 28px rgba(18, 37, 58, 0.18);
}

.ai-agents__card {
  background: #fff;
  padding: 14px 16px;
  max-height: 60vh;
  overflow-y: auto;
}

.ai-agents__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.ai-agents__card-name {
  font-size: 14px;
  font-weight: 700;
  color: #12253a;
}

.ai-agents__card .ai-agents__desc {
  margin: 0 0 8px;
  font-size: 12.5px;
  line-height: 1.45;
  color: #6e6e80;
}

.ai-agents__card .ai-agents__sub {
  margin: 10px 0 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8e8ea0;
}

.ai-agents__card .ai-agents__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ai-agents__card .ai-agents__item-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12.5px;
  line-height: 1.35;
  color: #353740;
}

.ai-agents__card .ai-agents__item-row .v-icon {
  margin-top: 1px;
}
</style>
